import { AssetActionHandlers } from '@/sections/asset/types';
import { Asset } from '@/types';
import type { DropdownOption } from '@/types/dropdown.types';

import { getAssetAnnotateOptions } from './annotateOptions';
import { getAssetDistributeOptions } from './distributeOptions';
import { getAssetScanOptions } from './scanOptions';
import { getAssetStatusOptions } from './statusOptions';

export interface GetAssetActionOptionsParams {
  /** Assets to perform actions on */
  assets: Asset[];
  /** Handler for opening comment modal */
  onCommentClick?: () => void;
  /** Handler for opening tag modal */
  onTagClick?: () => void;
  /** Action handlers for scan, status, and share operations */
  handlers: AssetActionHandlers;
  /** User agentselection state from global state */
  selectUserAgent: { onAssetKeysChange: (keys: string[]) => void };
  /** Whether the current user is a Praetorian user */
  isPraetorianUser: boolean;
  /**
   * Handler for removing scan profile from the row asset.
   * When provided, adds "Remove Scan Profile" to the annotate options.
   * Routes through the bulk endpoint — per-item PUT is broken for profile clears.
   */
  onRemoveProfileClick?: () => void;
}

export const getAssetActionOptions = ({
  assets,
  onCommentClick,
  onTagClick,
  handlers,
  selectUserAgent,
  isPraetorianUser,
  onRemoveProfileClick,
}: GetAssetActionOptionsParams): DropdownOption[] => {
  const hasProfileAssets = assets.some(a => !!a.profile);

  const annotateOptions = getAssetAnnotateOptions({
    onCommentClick,
    onTagClick,
    onRemoveProfileClick,
    hasProfileAssets,
  });

  const scanOptions = getAssetScanOptions({
    assets,
    handlers,
    selectUserAgent,
    isPraetorianUser,
  });

  const distributeOptions = getAssetDistributeOptions({
    assets,
    handlers,
  });

  const statusOptions = getAssetStatusOptions({
    assets,
    handlers,
    isPraetorianUser,
  });

  // Combine all options with dividers between groups
  return [
    ...annotateOptions,
    { label: '', isDivider: true },
    ...scanOptions,
    { label: '', isDivider: true },
    ...distributeOptions,
    { label: '', isDivider: true },
    ...statusOptions,
  ];
};
